import { __assign, __read, __values } from "tslib";
import React from "react";
import classNames from "classnames";
import { Text } from "../../text";
import { Icon } from "../../icon";
import { useConfig } from "../../_util/config-context";
import { getValueByPathKey } from "../util/get-value-by-path-key";
export function sortable(options) {
    // 当前列的排序优先级
    var sortablePrefer = new Map((options.columns || []).map(function (column) {
        return typeof column === "string"
            ? [column, "asc"]
            : [column.key, column.prefer];
    }));
    // 当前列的自定义排序函数
    var sortableCompare = new Map((options.columns || []).map(function (column) {
        return typeof column === "string"
            ? [column, undefined]
            : [column.key, column.sorter];
    }));
    // 当前列的排序状态
    var sortMap = new Map((options.value || []).map(function (sort) { return [sort.by, sort.order]; }));
    return {
        getInfo: function () { return ({ name: "sortable" }); },
        onInjectColumn: function (renderColumn) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var columnResult = renderColumn(record, rowKey, recordIndex, column, columnIndex);
            // recordIndex > -1 是记录行，我们只注入表头
            if (recordIndex > -1) {
                return columnResult;
            }
            // 不是可排序列，跳过
            if (!sortablePrefer.has(column.key)) {
                return columnResult;
            }
            // 获取原始渲染内容
            var children = columnResult.children;
            // 当前的排序状态 undefined | "asc" | "desc"
            var order = sortMap.get(column.key);
            // 当前列的自定义排序函数
            var sorter = sortableCompare.get(column.key);
            // 切换排序状态
            var changeOrder = function (event) {
                if (typeof options.onChange !== "function") {
                    return;
                }
                var nextOrder;
                var prefer = sortablePrefer.get(column.key);
                if (!order) {
                    nextOrder = prefer;
                }
                if (order === "asc") {
                    nextOrder = prefer === "asc" ? "desc" : undefined;
                }
                if (order === "desc") {
                    nextOrder = prefer === "asc" ? undefined : "asc";
                }
                var sort = {
                    by: column.key,
                    order: nextOrder,
                    sorter: sorter,
                };
                // 删除旧排序规则，保证新的在前
                sortMap.delete(column.key);
                var value = (nextOrder ? [sort] : []).concat(Array.from(sortMap).map(function (_a) {
                    var _b = __read(_a, 2), by = _b[0], order = _b[1];
                    return ({ by: by, order: order });
                }));
                options.onChange(value, { event: event, sort: sort });
            };
            // 包装一个排序按钮
            children = (React.createElement(SortButton, { order: order, onClick: changeOrder }, children));
            return __assign(__assign({}, columnResult), { children: children });
        }; },
    };
}
export function SortButton(_a) {
    var order = _a.order, className = _a.className, style = _a.style, children = _a.children, onClick = _a.onClick;
    var classPrefix = useConfig().classPrefix;
    var iconType = "sort";
    if (order === "asc") {
        iconType = "sortup";
    }
    if (order === "desc") {
        iconType = "sortdown";
    }
    return (React.createElement("span", { className: classNames(classPrefix + "-table__sortbtn", { "is-active": Boolean(order) }, className), style: style, onClick: onClick },
        React.createElement(Text, { overflow: true, className: classPrefix + "-table__headerop" }, children),
        React.createElement(Icon, { type: iconType })));
}
function comparer(sorts) {
    return function (a, b) {
        var e_1, _a;
        try {
            for (var sorts_1 = __values(sorts), sorts_1_1 = sorts_1.next(); !sorts_1_1.done; sorts_1_1 = sorts_1.next()) {
                var _b = sorts_1_1.value, by = _b.by, order = _b.order, sorter = _b.sorter;
                var hasSorter = typeof sorter === "function";
                var firstValue = getValueByPathKey(a, by);
                var secondValue = getValueByPathKey(b, by);
                var isAsc = hasSorter ? sorter(a, b) < 0 : firstValue < secondValue;
                var isDesc = hasSorter ? sorter(a, b) > 0 : firstValue > secondValue;
                if (isAsc || isDesc) {
                    if (order === "asc")
                        return isAsc ? -1 : 1;
                    if (order === "desc")
                        return isDesc ? -1 : 1;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sorts_1_1 && !sorts_1_1.done && (_a = sorts_1.return)) _a.call(sorts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return 0;
    };
}
sortable.comparer = comparer;
//# sourceMappingURL=sortable.js.map